module.exports = __webpack_public_path__ + "img/xygz.3ffafb07.png";